import {Injectable} from "@angular/core";
import {AuthApiService} from "../auth/auth-api.service";
import {CustomerPortalStatusData} from "./customer-portal-status.data";
import {HttpClient} from "@angular/common/http";
import {firstValueFrom} from "rxjs";

@Injectable()
export class CustomerPortalService {

    constructor(private http: HttpClient, private auth: AuthApiService) {
    }

    async generateCustomerPortalUrl(venueId: string): Promise<string> {
        return firstValueFrom(this.http.get("/fonzie/customer-instance-venue/" + venueId + "/generate-customer-portal-url", {
            headers: this.auth.getHttpHeaderOptions(),
            responseType: "text"
        }));
    }

    async getCustomerPortalStatus(): Promise<CustomerPortalStatusData> {
        return firstValueFrom(this.http.get<CustomerPortalStatusData>("/fonzie/customer-portal", {headers: this.auth.getHttpHeaderOptions()}));
    }

    async sendCustomerPortalUrl(venueId: string): Promise<void> {
        return firstValueFrom(this.http.post<void>("/fonzie/customer-instance-venue/" + venueId + "/send-customer-portal-url", {}, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async confirmPaymentMethod(venueId: string, paymentMethodId: string): Promise<void> {
        return firstValueFrom(this.http.post<void>("/fonzie/customer-instance-venue/" + venueId + "/confirm-payment-method?id=" + paymentMethodId, {}, {headers: this.auth.getHttpHeaderOptions()}));
    }

    getUrlParameter(parameter: string): any {
        const parametersHash: string = window.location.hash.substring(window.location.hash.indexOf("?") + 1);
        const parameters: string[] = parametersHash.split("&");

        for (let i = 0; i < parameters.length; i++) {
            const singleParam: string[] = parameters[i].split("=");
            if (singleParam[0] === parameter) {
                return singleParam[1];
            }
        }
        return undefined;
    }
}
